import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Çerez kullanıyoruz',
    description:
      'Bu deneyimi sunmak için çerezleri ve benzer teknolojileri kullanıyoruz. Kesinlikle gerekli çerezler her zaman etkindir.',
    allow_label: 'Tüm çerezleri kabul et',
    reject_label: 'Yalnızca kesinlikle gerekli olanlar',
    settings_label: 'Çerez ayarları',
    policy_link_label: 'Gizlilik ve çerez politikası',
    categories_label: 'Kategoriler',
    always_on_label: 'Her zaman etkin',
    required_label: 'Gerekli',
    save_preferences_label: 'Tercihleri kaydet',
    close_label: 'Kapat',
    allow_all_optional_categories_label: 'Tüm isteğe bağlı kategorilere izin ver',
    save_error: 'Gizlilik seçiminiz kaydedilemedi. Lütfen tekrar deneyin.'
  },
  categories: {
    strictly_necessary: {
      name: 'Kesinlikle gerekli',
      purpose: 'Bu deneyimi sunmak için gereklidir ve devre dışı bırakılamaz.'
    },
    analytics: {
      name: 'Analiz',
      purpose: 'Performansı iyileştirmek için ziyaretçilerin bu deneyimi nasıl kullandığını ölçer.'
    },
    marketing: { name: 'Pazarlama', purpose: 'Organizatörün seçtiği reklam ve pazarlamayı destekler.' }
  }
};

export default locale;
